<template>
  <div class="modal callback" :class="{ active: showModal }">
    <div class="container modal-top">
      <div class="modal-top__back-Link" @click="$emit('modal', 'callback')">
        <BackIcon />
      </div>
      <div class="modal-top__title">Обратная связь</div>
    </div>
    <div class="container callback-container">
      <div class="callback-rate">
        <div class="callback-rate__text">Оцените работу приложения</div>
        <div class="callback-rate__stars">
          <div
            class="callback-rate__stars-item"
            @click="() => setRate(1)"
            :class="{ active: rate > 0 }"
          >
            <StarIcon />
          </div>
          <div
            class="callback-rate__stars-item"
            @click="() => setRate(2)"
            :class="{ active: rate > 1 }"
          >
            <StarIcon />
          </div>
          <div
            class="callback-rate__stars-item"
            @click="() => setRate(3)"
            :class="{ active: rate > 2 }"
          >
            <StarIcon />
          </div>
          <div
            class="callback-rate__stars-item"
            @click="() => setRate(4)"
            :class="{ active: rate > 3 }"
          >
            <StarIcon />
          </div>
          <div
            class="callback-rate__stars-item"
            @click="() => setRate(5)"
            :class="{ active: rate > 4 }"
          >
            <StarIcon />
          </div>
        </div>
      </div>
      <div class="callback-queshtion">
        <div class="callback-queshtion__text">Ваш e-mail</div>
        <div class="callback-queshtion__input callback-input">
          <input :placeholder="'E-mail'" v-model="email" />
        </div>
      </div>
      <div class="callback-queshtion">
        <div class="callback-queshtion__text">Связаться с командой ВПШ+</div>
        <div class="callback-queshtion__textarea">
          <textarea
            :placeholder="'Напишите ваш вопрос'"
            v-model="queshtion"
            rows="6"
          ></textarea>
        </div>
      </div>
      <p>{{ sendResult }}</p>
      <div class="callback-buttons">
        <ButtonEl @click="sendCallback">Отправить</ButtonEl>
      </div>
    </div>
  </div>
</template>

<script>
import StarIcon from '@/components/icons/StarIcon.vue';
import BackIcon from '@/components/icons/BackIcon.vue';
import ButtonEl from '@/components/blocks/buttons/ButtonEl.vue';
import { callbackSend } from '@/functions/API';
import { showPopup } from '@/functions/popup';

export default {
  name: 'CallbackModal',
  components: {
    StarIcon,
    BackIcon,
    ButtonEl,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      rate: 0,
      email: '',
      queshtion: '',
      sendResult: '',
      errors: [],
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show() {
      this.showModal = this.show;
    },
  },
  methods: {
    setRate(val) {
      this.rate = val;
    },
    sendCallback() {
      const data = {
        mark: this.rate,
        email: this.email,
        content: this.queshtion,
      };
      callbackSend(data, (res) => {
        if (res?.ok == true) {
          this.rate = 0;
          this.email = '';
          this.queshtion = '';
          showPopup(res.data.message, '', () => {});
        } else {
          if (res?.error?.response?.data?.errors) {
            const errors = res.error.response.data.errors;
            var errorsText = '';
            Object.keys(errors).map(function (objectKey) {
              errorsText += errors[objectKey][0] + '\n';
            });
            showPopup(errorsText, '', () => {});
          } else {
            showPopup('Форма заполнена некорректно.', '', () => {});
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &-top {
    position: relative;
    background-color: var(--color-white);
    color: var(--color-black);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    &__back-Link {
      color: var(--color-blue);
      cursor: pointer;
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &__title {
      color: var(--color-black);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
  }
}
.callback {
  position: fixed;
  left: 0;
  top: 120%;
  height: 100%;
  width: 100%;
  background-color: var(--color-white);
  transition: 0.3s ease-in-out;
  overflow-y: auto;
  &.active {
    top: 0;
  }
  &-container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 16px;
    margin-bottom: 16px;
    height: calc(100% - 87px);
    min-height: 500px;
  }
  &-rate {
    display: flex;
    flex-direction: column;
    gap: 16px;
    &__text {
      color: var(--color-black);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 133%;
    }
    &__stars {
      display: flex;
      gap: 4px;
      align-items: center;
      &-item {
        fill: none;
        stroke: var(--color-gray-middle);
        cursor: pointer;
        &.active {
          fill: var(--color-blue);
          stroke: var(--color-blue);
        }
        svg {
          width: 24px;
          height: 24px;
          min-width: 24px;
          min-height: 24px;
        }
      }
    }
  }
  &-input {
    width: 100%;
    input {
      width: 100%;
      height: 40px;
      border: none;
      border-radius: 8px;
      background-color: var(--color-gray-light);
      padding: 0 20px;
      color: var(--color-black);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%;
      &::placeholder {
        color: var(--color-gray);
      }
    }
  }
  &-queshtion {
    display: flex;
    flex-direction: column;
    gap: 16px;
    &__text {
      color: var(--color-black);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 133%;
    }
    &__textarea {
      textarea {
        resize: none;
        width: 100%;
        padding: 12px 20px;
        border: none;
        background-color: var(--color-gray-light);
        border-radius: 12px;
        color: var(--color-black);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%;
        &::-webkit-scrollbar {
          width: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background: var(--color-blue);
        }
      }
    }
  }
  &-buttons {
    position: absolute;
    bottom: 16px;
    left: 50%;
    width: calc(100% - 32px);
    max-width: calc(600px - 32px);
    transform: translateX(-50%);
  }
}
</style>
